import { Box, Typography, Grid } from "@mui/material";
import { CompanyRecord } from "../../types";

const CompanyEntityHeader = ({ company }: { company: CompanyRecord }) => {
  if (!company) return null;

  return (
    <Box sx={{ p: 1, bgcolor: "#f5f5f5", borderRadius: 1 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 0.5 }}>
        Blacklist Details
      </Typography>

      <Grid container spacing={0.25}>
        <Grid item xs={12}>
          <Typography variant="body2">
            <strong>Blacklist Type:</strong> Entity
          </Typography>
        </Grid>

        {company.name && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Name:</strong> {company.name}
            </Typography>
          </Grid>
        )}

        {company.companyType && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Entity Type:</strong> {company.companyType.name}
            </Typography>
          </Grid>
        )}

        {company.taxID && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Tax ID:</strong> {company.taxID}
            </Typography>
          </Grid>
        )}

        {company.bulletins && company.bulletins.length > 0 && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Bulletins:</strong> {company.bulletins.length}
            </Typography>
          </Grid>
        )}

        {company.createdDate && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Created:</strong> {new Date(company.createdDate).toLocaleDateString()}
            </Typography>
          </Grid>
        )}

        {company.createdByUser && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Created By:</strong> {company.createdByUser.fullName}
            </Typography>
          </Grid>
        )}
      </Grid>

      {company.notes && (
        <Box sx={{ mt: 0.25 }}>
          <Typography variant="body2">
            <strong>Notes:</strong> {company.notes}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default CompanyEntityHeader;
